import {
  Box,
  Button,
  Menu,
  Select,
  Skeleton,
  Text,
  UnstyledButton,
} from "@mantine/core";
import DraftNotesTab from "../../../components/DraftNotesTab";

import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import NoteTypeSelectModal from "../../../components/NoteSelectTypeModal";
import NoteTable from "../../../components/NoteTable";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import { getAllFacilitiesModal, getAllFacilityTypes } from "../../../services";
import {
  getAllDrafts,
  getAllNoteTypes,
  getNotes,
  getSingleNote,
} from "../../../services/note";
import { getAllPatientsModal } from "../../../services/patient";
import { getAllStaff } from "../../../services/staff";
import { getAllPlans } from "../../../services/supportplan";
import { DatePickerInput } from "@mantine/dates";
import moment from "moment";
import useStyles, { notePaginationStyles } from "./style";
import { TrackPageView } from "../../../config/mixpanelConfig";
import AddEssentialNote from "../../../components/AddEssentialNote/AddEssentialNote";
import { Billing_Services_Note, Essential_Support_Note } from "../../../http";
import { getBillingProvider } from "../../../services/billingprovider";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import NoteDrawer from "../../../components/NoteModal/NewNoteDesignCopy";
import {
  LuArrowUpDown,
  LuChevronDown,
  LuChevronLeft,
  LuClock,
  LuFile,
  LuFileText,
  LuPlus,
  LuRotateCcw,
  LuSearch,
  LuSettings,
  LuX,
} from "react-icons/lu";
import { IoFilter } from "react-icons/io5";
import useDebounce from "../../../utils/useDebounce";
import { clearNotes } from "../../../store/reducers/note";
import { getAllSignatures } from "../../../services/signature";
import { getNoteSettings } from "../../../services/noteSettings";
import NoteModalNew from "../../../components/NoteModal/NoteModalNew";
import NoteReportDrawer from "../../../components/NoteReportModal";
import UsePreviousNoteDrawer from "../../../components/UsePreviousNoteDrawer";

const STATUS_TABS = [
  { key: "all", label: "All" },
  { key: "pending", label: "Pending" },
  { key: "approved", label: "Approved" },
  { key: "rejected", label: "Rejected" },
  { key: "drafts", label: "Drafts" },
];

const ITEMS_PER_PAGE = 10;

const Note = (props) => {
  const { notes, loading, drafts } = useSelector((state) => state?.note);
  const { singleNote } = useSelector((state) => state?.note);
  const { profile } = useSelector((state) => state.profile);
  const [data, setData] = useState(null);
  const [view, setView] = useState(false);
  const [isopen, setOpen] = useState(false);
  const [isViewNoteOpen, setIsViewNoteOpen] = useState(false);
  // Plain "View" keeps Approve/Reject hidden (existing behavior); the
  // kebab's own Approve/Reject items open this same drawer with them shown.
  const [hideApproveReject, setHideApproveReject] = useState(true);
  const [noteType, setNoteType] = useState(null);
  const [dateRange, setDateRange] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [sortOpen, setSortOpen] = useState(false);
  const [dateRangeVal, setDateRangeVal] = useState([]);
  const [opened, { open, close }] = useDisclosure(false);
  const [oneDayValue, setOneDayValue] = useState(null);
  const [sortField, setSortField] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("descending");
  const [openModal, setOpenModal] = useState(false);
  const [billingServices, setBillingServices] = useState("");
  const [progressNoteState, setProgressNoteState] = useState("");
  const [resetPatientTrigger, setResetPatientTrigger] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusTab, setStatusTab] = useState("all");
  const [newNoteMenuOpen, setNewNoteMenuOpen] = useState(false);
  const [prevNoteOpened, setPrevNoteOpened] = useState(false);
  const [saveAsNewNote, setSaveAsNewNote] = useState(false);
  const [
    noteReportDrawerOpened,
    { open: noteReportDrawerOpen, close: noteReportDrawerClose },
  ] = useDisclosure(false);
  const [activeFilters, setActiveFilters] = useState({
    facility: null,
    createdBy: null,
    noteTypeFilter: null,
    client: null,
  });
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [tempFacility, setTempFacility] = useState(null);
  const [tempCreatedBy, setTempCreatedBy] = useState(null);
  const [tempNoteType, setTempNoteType] = useState(null);
  const [tempClient, setTempClient] = useState(null);
  const [draftUserId, setDraftUserId] = useState(null);
  const navigate = useNavigate();

  // Same "duplicate as new note" flow as "Use a Previous Note" 's onUseNote,
  // triggered from a table row's kebab menu instead of the picker drawer.
  const handleDuplicateNote = (row) => {
    getAllStaff("all");
    setData(row);
    setSaveAsNewNote(true);
    setOpen(true);
  };

  const handleEditDraft = (draft) => {
    setNoteType(draft.noteType?._id || draft.noteType);
    // Incident Report drafts store `client` as an array (resolved patient
    // objects, one per involved client) — any single one is enough to open
    // the drawer and find this same draft (the backend matches by
    // membership), so just take the first.
    const clientValue = Array.isArray(draft.client) ? draft.client[0] : draft.client;
    setDraftUserId(clientValue?._id || clientValue);
    setOpen(true);
  };

  // Open a draft in the read-only view drawer (NoteModalNew), shown with a
  // "Draft" status. A draft isn't a Note document — its content lives in
  // `formState` (fields + descriptions/essentialSupport/goals + toggles) and
  // its type is a populated object — so reshape it into the same
  // { fields, noteId, descriptions, ... } form a submitted note has.
  const openDraftView = (draft) => {
    const typeId = draft.noteType?._id || draft.noteType;
    const noteLike = {
      ...(draft.formState || {}),
      _id: draft._id,
      id: draft._id,
      // NoteModalNew derives its layout from data.data.noteId — give it an
      // object carrying an `id` so the lookup against allNotesTypes resolves.
      noteId: { id: String(typeId), _id: typeId, name: draft.noteType?.name },
      approvalStatus: "draft",
      isDraft: true,
      createdAt: draft.createdAt,
      updatedAt: draft.updatedAt,
    };
    setView(true);
    setData(noteLike);
    setIsViewNoteOpen(true);
  };
  const { classes, cx } = useStyles();

  const { allDeletedFacilities } = useSelector((state) => state?.facility);
  const { allStaff } = useSelector((state) => state?.staff);
  const { allNotesTypes } = useSelector((state) => state?.note);
  const { allPatients } = useSelector((state) => state?.patient);

  const debouncedSearch = useDebounce(searchTerm, 2000);
  const dispatch = useDispatch();

  // Status tab (Pending/Approved/Rejected) is sent to the backend as an
  // approvalStatus filter, so pagination and the status/KPI counts (returned
  // alongside the notes on the same response) both come straight from the
  // server instead of being computed from a client-side "fetch everything".
  const statusFilters = {
    ...activeFilters,
    approvalStatus:
      statusTab !== "all" && statusTab !== "drafts" ? statusTab : undefined,
  };

  useEffect(() => {
    getNotes(
      currentPage,
      null,
      true,
      dateRange,
      sortField,
      sortOrder,
      debouncedSearch || undefined,
      statusFilters,
    );
  }, [currentPage, dateRange, activeFilters, debouncedSearch, statusTab]);

  // Same refresh pattern NoteTableRow's own delete uses (re-fetch from the
  // server instead of splicing local state), with no loading flash.
  const refetchNotes = () => {
    getNotes(
      currentPage,
      null,
      false,
      dateRange,
      sortField,
      sortOrder,
      debouncedSearch || undefined,
      statusFilters,
    );
  };

  useEffect(() => {
    getAllPlans();
    getAllNoteTypes();
    getAllFacilityTypes();
    getAllPatientsModal("withDeleted");
    getAllFacilitiesModal("withDeleted");
    getAllStaff("all");
    getBillingProvider();
    getAllSignatures();
    getAllDrafts(dispatch);
    getNoteSettings();

    TrackPageView("Note");
  }, []);

  useEffect(() => {
    return () => {
      dispatch(clearNotes());
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const noteId = params.get("noteId");
    if (noteId) {
      getSingleNote(noteId);
      setOpen(true);
    }
  }, []);

  useEffect(() => {
    if (singleNote) {
      setData(singleNote);
    }
  }, [singleNote]);

  // Reset to page 1 whenever the visible set changes shape.
  useEffect(() => {
    setCurrentPage(1);
  }, [statusTab, activeFilters, dateRange, debouncedSearch]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleDateRange = (dates) => {
    if (dates[0] == null && dates[1] == null) {
      setDateRangeVal([]);
    } else {
      setDateRangeVal(dates);
    }
  };

  const handleDateChange = (date) => {
    setOneDayValue(date);
  };

  const handleSaveDateRange = () => {
    if (dateRangeVal?.length) {
      let startDate = moment(dateRangeVal[0]).startOf("day");
      let endDate = moment(dateRangeVal[1]).endOf("day");
      setDateRange([startDate, endDate]);
    } else if (oneDayValue) {
      let startDate = moment(oneDayValue).startOf("day");
      let endDate = moment(oneDayValue).endOf("day");
      setDateRange([startDate, endDate]);
    }
    setDropdownOpen(false);
  };

  const handleSaveSort = () => {
    getNotes(
      currentPage,
      null,
      true,
      dateRange,
      sortField,
      sortOrder,
      debouncedSearch || undefined,
      statusFilters,
    );
    setSortOpen(false);
  };

  const handleSortChange = (field, order) => {
    setSortField(field);
    setSortOrder(order);
  };

  const handleCancelDateRange = () => {
    setDateRangeVal([]);
    setDateRange(null);
    setDropdownOpen(false);
  };

  const handleResetSort = () => {
    setSortField("createdAt");
    setSortOrder("descending");
    getNotes(
      currentPage,
      null,
      true,
      dateRange,
      "createdAt",
      "descending",
      debouncedSearch || undefined,
      statusFilters,
    );
    setSortOpen(false);
  };

  const hasActiveFilters =
    activeFilters?.facility ||
    activeFilters?.createdBy ||
    activeFilters?.noteTypeFilter ||
    activeFilters?.client ||
    dateRange;

  const filterCount = [
    activeFilters?.facility,
    activeFilters?.client,
    activeFilters?.createdBy,
    activeFilters?.noteTypeFilter,
    dateRange,
  ].filter(Boolean).length;

  const getFacilityName = (id) => {
    const fac = allDeletedFacilities?.facilities?.find((f) => f.id === id);
    return fac?.name || id;
  };

  const getStaffName = (id) => {
    const staff = allStaff?.find((s) => s?.id === id);
    return (
      staff?.name ||
      `${staff?.firstName || ""} ${staff?.lastName || ""}`.trim() ||
      id
    );
  };

  const getNoteTypeName = (id) => {
    const nt = allNotesTypes?.ntypes?.find((n) => n?.id === id);
    return nt?.name || id;
  };

  const getClientName = (id) => {
    const patient = allPatients?.find((p) => p?.id === id);
    return patient?.name || id;
  };

  const handleApplyFilter = () => {
    const newFilters = { ...activeFilters };
    if (selectedCategory === "facility" && tempFacility) {
      newFilters.facility = tempFacility;
    }
    if (selectedCategory === "staff" && tempCreatedBy) {
      newFilters.createdBy = tempCreatedBy;
    }
    if (selectedCategory === "noteType" && tempNoteType) {
      newFilters.noteTypeFilter = tempNoteType;
    }
    if (selectedCategory === "client" && tempClient) {
      newFilters.client = tempClient;
    }
    if (selectedCategory === "date") {
      handleSaveDateRange();
    }
    setActiveFilters(newFilters);
    setDropdownOpen(false);
    setSelectedCategory(null);
  };

  const handleResetAllFilters = () => {
    setActiveFilters({
      facility: null,
      createdBy: null,
      noteTypeFilter: null,
      client: null,
    });
    setDateRange(null);
    setDateRangeVal([]);
    setOneDayValue(null);
    setTempFacility(null);
    setTempCreatedBy(null);
    setTempNoteType(null);
    setTempClient(null);
    setSelectedCategory(null);
    setDropdownOpen(false);
  };

  const handleRemoveFilter = (key) => {
    if (key === "date") {
      setDateRange(null);
      setDateRangeVal([]);
      setOneDayValue(null);
    } else {
      setActiveFilters((prev) => ({ ...prev, [key]: null }));
    }
  };

  const handleAddEssential = () => {
    if (billingServices) {
      setNoteType(Billing_Services_Note);
    } else {
      setNoteType(Essential_Support_Note);
    }
    setOpen(true);
  };

  // ---- status/KPI counts come straight from the backend (same response as the notes page) ----
  const statusCounts = notes?.statusCounts || {
    all: 0,
    pending: 0,
    approved: 0,
    rejected: 0,
    today: 0,
    oldestPendingAt: null,
  };

  // Drafts live only on their own tab — they aren't Note documents, so the
  // backend's statusCounts never sees them and "All" stays
  // Pending + Approved + Rejected. Their count comes from the drafts store.
  const tabCounts = {
    ...statusCounts,
    drafts: drafts?.length || 0,
  };

  const todayCount = statusCounts.today || 0;

  const oldestPendingDays = statusCounts.oldestPendingAt
    ? Math.max(0, moment().diff(moment(statusCounts.oldestPendingAt), "days"))
    : null;

  const decidedCount = (statusCounts.approved || 0) + (statusCounts.rejected || 0);
  const approvalRate = decidedCount
    ? Math.round((statusCounts.approved / decidedCount) * 100)
    : null;

  return (
    <Box fluid className={classes.content}>
      <AddEssentialNote
        openModal={openModal}
        setOpenModal={setOpenModal}
        onConfirm={handleAddEssential}
        billingServices={billingServices}
        setBillingServices={setBillingServices}
        onAddLater={() => {
          setResetPatientTrigger((c) => c + 1);
          setProgressNoteState("");
        }}
      />
      <NoteDrawer
        data={data}
        opened={isopen}
        viewOpened={isViewNoteOpen}
        noteType={noteType}
        userId={draftUserId}
        autoRestoreDraft={!!draftUserId}
        title={"Add New Note"}
        saveAsNew={saveAsNewNote}
        close={() => {
          setOpen(false);
          setData(null);
          setNoteType();
          setDraftUserId(null);
          setSaveAsNewNote(false);
          // The drawer may have auto-saved/updated a draft while it was
          // open (Cancel button, X icon, or an outside click all end up
          // here) — refresh the drafts store so the Drafts tab count stays
          // accurate even when the user closes without clicking Save.
          // Drafts themselves are never merged into the notes tabs.
          if (statusTab !== "drafts") getAllDrafts(dispatch, null, false);
        }}
        sortField={sortField}
        sortOrder={sortOrder}
        currentPage={currentPage}
        dateRange={dateRange}
        activeFilters={activeFilters}
        setOpenModal={setOpenModal}
        setBillingServices={setBillingServices}
        setProgressNoteState={setProgressNoteState}
        progressNoteState={progressNoteState}
        resetPatientTrigger={resetPatientTrigger}
      />

      <UsePreviousNoteDrawer
        opened={prevNoteOpened}
        close={() => setPrevNoteOpened(false)}
        onUseNote={(sourceNote) => {
          setPrevNoteOpened(false);
          getAllStaff("all");
          setData(sourceNote);
          setSaveAsNewNote(true);
          setOpen(true);
        }}
      />

      <NoteModalNew
        opened={isViewNoteOpen}
        close={() => {
          setIsViewNoteOpen(false);
          setData(null);
        }}
        hideApproveRejectButtons={hideApproveReject}
        onApprovalChanged={refetchNotes}
        noteType={noteType}
        title={"Add New Note"}
        view={view}
        setView={setView}
        data={data}
      />

      <AppNavbar title={"Note"} profile={profile} />

      <Box className={classes.wrap}>
        {/* Create / Report / Settings row */}
        <Box className={classes.pageActions}>
          <Menu
            width={300}
            shadow="md"
            radius="md"
            position="bottom-start"
            opened={newNoteMenuOpen}
            onClose={() => setNewNoteMenuOpen(false)}
          >
            <Menu.Target>
              <Button
                size="md"
                radius="md"
                leftIcon={<LuPlus size={16} />}
                rightIcon={<LuChevronDown size={14} />}
                className={classes.btnPrimary}
                onClick={() => setNewNoteMenuOpen((o) => !o)}
              >
                Create Note
              </Button>
            </Menu.Target>
            <Menu.Dropdown className={classes.newMenuDropdown}>
              <UnstyledButton
                className={classes.newMenuItemBtn}
                onClick={() => {
                  setNewNoteMenuOpen(false);
                  getAllStaff("all");
                  setOpen(true);
                }}
              >
                <Box className={classes.newMenuIco}>
                  <LuPlus size={16} />
                </Box>
                <Box className={classes.newMenuInfo}>
                  <Text className={classes.newMenuTitle}>Start a New Note</Text>
                </Box>
              </UnstyledButton>
              <UnstyledButton
                className={`${classes.newMenuItemBtn} ${classes.newMenuItemBordered}`}
                onClick={() => {
                  setNewNoteMenuOpen(false);
                  setPrevNoteOpened(true);
                }}
              >
                <Box className={classes.newMenuIco}>
                  <LuFileText size={16} />
                </Box>
                <Box className={classes.newMenuInfo}>
                  <Text className={classes.newMenuTitle}>Use a Previous Note</Text>
                </Box>
              </UnstyledButton>
            </Menu.Dropdown>
          </Menu>
          <Box className={classes.spacer} />
          <Button
            size="md"
            radius="md"
            leftIcon={<LuFile size={15} />}
            className={classes.btnGhost}
            onClick={noteReportDrawerOpen}
          >
            Reports
          </Button>
          {(profile?.user?.type !== "staff" ||
            (profile?.user?.role === "admin" &&
              profile?.user?.permissions?.noteSettings === true)) && (
            <Button
              size="md"
              radius="md"
              className={classes.btnGhost}
              onClick={() => navigate("/home/notetype")}
            >
              <LuSettings size={16} />
            </Button>
          )}
        </Box>

        {/* KPI cards */}
        <Box className={classes.kpis}>
          <Box className={classes.kpi}>
            <Box className={classes.kpiTop}>
              <Box className={cx(classes.kpiIcon, classes.kpiIconInfo)}>
                <LuFileText size={16} />
              </Box>
              <Text className={classes.kpiLabel}>Notes today</Text>
            </Box>
            {loading ? (
              <Skeleton height={26} width={44} radius="sm" />
            ) : (
              <Text className={classes.kpiVal}>{todayCount}</Text>
            )}
            {loading ? (
              <Skeleton height={12} width={90} radius="sm" mt={6} />
            ) : (
              <Text className={classes.kpiSub}>
                <b>{tabCounts.all}</b> total notes
              </Text>
            )}
          </Box>
          <Box className={classes.kpi}>
            <Box className={classes.kpiTop}>
              <Box className={cx(classes.kpiIcon, classes.kpiIconWarn)}>
                <LuClock size={16} />
              </Box>
              <Text className={classes.kpiLabel}>Pending approval</Text>
            </Box>
            {loading ? (
              <Skeleton height={26} width={44} radius="sm" />
            ) : (
              <Text className={classes.kpiVal}>{statusCounts.pending}</Text>
            )}
            {loading ? (
              <Skeleton height={12} width={110} radius="sm" mt={6} />
            ) : (
              <Text className={classes.kpiSub}>
                {oldestPendingDays !== null ? (
                  <>
                    Oldest waiting{" "}
                    <b>
                      {oldestPendingDays} day{oldestPendingDays === 1 ? "" : "s"}
                    </b>
                  </>
                ) : (
                  "Nothing waiting"
                )}
              </Text>
            )}
          </Box>
          <Box className={classes.kpi}>
            <Box className={classes.kpiTop}>
              <Box className={cx(classes.kpiIcon, classes.kpiIconDanger)}>
                <LuRotateCcw size={16} />
              </Box>
              <Text className={classes.kpiLabel}>Needs resubmit</Text>
            </Box>
            {loading ? (
              <Skeleton height={26} width={44} radius="sm" />
            ) : (
              <Text className={classes.kpiVal}>{statusCounts.rejected}</Text>
            )}
            {loading ? (
              <Skeleton height={12} width={100} radius="sm" mt={6} />
            ) : (
              <Text className={classes.kpiSub}>
                {approvalRate !== null ? (
                  <>
                    <b>{approvalRate}%</b> approval rate
                  </>
                ) : (
                  "No decisions yet"
                )}
              </Text>
            )}
          </Box>
        </Box>

        {/* Toolbar: status tabs + search + filter + sort */}
        <Box className={classes.toolbar}>
          <Box className={classes.statusSeg}>
            {STATUS_TABS.map((t) => (
              <UnstyledButton
                key={t.key}
                className={classes.statusBtn}
                data-active={statusTab === t.key ? "true" : "false"}
                onClick={() => setStatusTab(t.key)}
              >
                {t.label}
                <Text component="span" className={classes.statusCount}>
                  {tabCounts[t.key] ?? 0}
                </Text>
              </UnstyledButton>
            ))}
          </Box>

          <Box className={classes.searchBox}>
            <LuSearch size={15} />
            <input
              placeholder="Search client, staff, note type…"
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Box>

          {statusTab !== "drafts" && (
            <Menu
              width={350}
              shadow="md"
              radius={"md"}
              opened={sortOpen}
              position="bottom-end"
              onClose={() => setSortOpen(false)}
            >
              <Menu.Target title="Sort">
                <Box
                  className={classes.FilterIcon}
                  onClick={() => setSortOpen(!sortOpen)}
                >
                  <LuArrowUpDown size={18} />
                </Box>
              </Menu.Target>

              <Menu.Dropdown>
                <Box className={classes.box_header}>
                  <Text size="md" weight={700}>
                    Sorting
                  </Text>
                  <Button variant="unstyled" p={0} onClick={handleResetSort}>
                    <LuX />
                  </Button>
                </Box>
                <Box className={classes.box_body}>
                  <Select
                    label="Sort By"
                    placeholder="Sort by"
                    data={[
                      { label: "Created Date", value: "createdAt" },
                      { label: "Note Date", value: "noteDate" },
                      { label: "Edited Date", value: "updatedAt" },
                    ]}
                    value={sortField}
                    onChange={(value) => handleSortChange(value, sortOrder)}
                  />
                  <Select
                    label="Sort Order"
                    placeholder="Sort Order"
                    data={[
                      { label: "Ascending", value: "ascending" },
                      { label: "Descending", value: "descending" },
                    ]}
                    value={sortOrder}
                    onChange={(value) => handleSortChange(sortField, value)}
                  />
                </Box>
                <Box className={classes.btn_container}>
                  <Button
                    size="sm"
                    radius={"md"}
                    color="gray"
                    variant="outline"
                    onClick={handleResetSort}
                  >
                    Reset
                  </Button>
                  <Button
                    size="sm"
                    radius={"md"}
                    disabled={loading}
                    onClick={handleSaveSort}
                    className={classes.btnPrimary}
                  >
                    Save
                  </Button>
                </Box>
              </Menu.Dropdown>
            </Menu>
          )}

          {statusTab !== "drafts" && (
            <Menu
              width={350}
              shadow="md"
              radius={"md"}
              opened={dropdownOpen}
              position="bottom-end"
              onClose={() => {
                setDropdownOpen(false);
                setSelectedCategory(null);
              }}
            >
              <Menu.Target title="Filter">
                <Button
                  size="md"
                  radius="md"
                  title="Filter"
                  leftIcon={<IoFilter size={15} />}
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  className={classes.btnGhost}
                >
                  Filter
                  {filterCount > 0 && (
                    <Text component="span" className={classes.fcount}>
                      {filterCount}
                    </Text>
                  )}
                </Button>
              </Menu.Target>

              <Menu.Dropdown>
                {!selectedCategory ? (
                  <>
                    <Box className={classes.box_header}>
                      <Text size="lg" weight={700}>
                        Filter
                      </Text>
                      <Button
                        variant="unstyled"
                        p={0}
                        onClick={() => setDropdownOpen(false)}
                      >
                        <LuX />
                      </Button>
                    </Box>
                    <Box className={classes.filterCategoryList}>
                      <Box
                        className={classes.filterCategoryItem}
                        onClick={() => {
                          setSelectedCategory("facility");
                          setTempFacility(activeFilters.facility);
                        }}
                      >
                        <Text>Facility</Text>
                        {activeFilters.facility && (
                          <Box className={classes.activeFilterDot} />
                        )}
                      </Box>
                      <Box
                        className={classes.filterCategoryItem}
                        onClick={() => {
                          setSelectedCategory("client");
                          setTempClient(activeFilters.client);
                        }}
                      >
                        <Text>Client Name</Text>
                        {activeFilters.client && (
                          <Box className={classes.activeFilterDot} />
                        )}
                      </Box>
                      <Box
                        className={classes.filterCategoryItem}
                        onClick={() => {
                          setSelectedCategory("staff");
                          setTempCreatedBy(activeFilters.createdBy);
                        }}
                      >
                        <Text>Staff Name</Text>
                        {activeFilters.createdBy && (
                          <Box className={classes.activeFilterDot} />
                        )}
                      </Box>
                      <Box
                        className={classes.filterCategoryItem}
                        onClick={() => {
                          setSelectedCategory("noteType");
                          setTempNoteType(activeFilters.noteTypeFilter);
                        }}
                      >
                        <Text>Note Type</Text>
                        {activeFilters.noteTypeFilter && (
                          <Box className={classes.activeFilterDot} />
                        )}
                      </Box>
                      <Box
                        className={classes.filterCategoryItem}
                        onClick={() => setSelectedCategory("date")}
                      >
                        <Text>Date</Text>
                        {dateRange && (
                          <Box className={classes.activeFilterDot} />
                        )}
                      </Box>
                    </Box>
                    <Box className={classes.btn_container}>
                      <Button
                        size="sm"
                        radius={"md"}
                        color="gray"
                        variant="outline"
                        onClick={handleResetAllFilters}
                      >
                        Reset All
                      </Button>
                    </Box>
                  </>
                ) : (
                  <>
                    <Box
                      className={classes.filterCategoryHeader}
                      onClick={() => setSelectedCategory(null)}
                    >
                      <LuChevronLeft size={16} />
                      <Text weight={600}>
                        {selectedCategory === "facility" && "Facility"}
                        {selectedCategory === "client" && "Client Name"}
                        {selectedCategory === "staff" && "Staff Name"}
                        {selectedCategory === "noteType" && "Note Type"}
                        {selectedCategory === "date" && "Date"}
                      </Text>
                    </Box>
                    <Box className={classes.box_body}>
                      {selectedCategory === "facility" && (
                        <Box className={classes.filterFields}>
                          <Select
                            label="Select Facility"
                            placeholder="Search facility..."
                            searchable
                            clearable
                            value={tempFacility}
                            onChange={setTempFacility}
                            data={
                              allDeletedFacilities?.facilities
                                ?.filter(
                                  (p) =>
                                    p?.active === true &&
                                    p?.deleted === false,
                                )
                                ?.map((f) => ({
                                  label: f?.name,
                                  value: f?.id,
                                })) || []
                            }
                          />
                        </Box>
                      )}
                      {selectedCategory === "client" && (
                        <Box className={classes.filterFields}>
                          <Select
                            label="Select Client"
                            placeholder="Search client..."
                            searchable
                            clearable
                            value={tempClient}
                            onChange={setTempClient}
                            data={
                              allPatients
                                ?.filter(
                                  (p) =>
                                    p?.active === true &&
                                    p?.deleted === false,
                                )
                                ?.map((p) => ({
                                  label: p?.name || "Unknown",
                                  value: p?.id,
                                })) || []
                            }
                          />
                        </Box>
                      )}
                      {selectedCategory === "staff" && (
                        <Box className={classes.filterFields}>
                          <Select
                            label="Select Staff"
                            placeholder="Search staff..."
                            searchable
                            clearable
                            value={tempCreatedBy}
                            onChange={setTempCreatedBy}
                            data={
                              allStaff
                                ?.filter(
                                  (p) =>
                                    p?.active === true &&
                                    p?.deleted === false,
                                )
                                ?.map((s) => ({
                                  label:
                                    s?.name ||
                                    `${s?.firstName || ""} ${
                                      s?.lastName || ""
                                    }`.trim(),
                                  value: s?.id,
                                })) || []
                            }
                          />
                        </Box>
                      )}
                      {selectedCategory === "noteType" && (
                        <Box className={classes.filterFields}>
                          <Select
                            label="Select Note Type"
                            placeholder="Search note type..."
                            searchable
                            clearable
                            value={tempNoteType}
                            onChange={setTempNoteType}
                            data={
                              allNotesTypes?.ntypes?.map((n) => ({
                                label: n?.name,
                                value: n?.id,
                              })) || []
                            }
                          />
                        </Box>
                      )}
                      {selectedCategory === "date" && (
                        <>
                          <Box className={classes.filterFields}>
                            <DatePickerInput
                              size="sm"
                              radius={"md"}
                              clearable
                              type="range"
                              value={dateRangeVal}
                              disabled={oneDayValue}
                              label="Select Date Range"
                              onChange={handleDateRange}
                              placeholder="Select Date Range"
                            />
                          </Box>
                          <Box className={classes.filterFields}>
                            <DatePickerInput
                              radius={"md"}
                              clearable
                              size="sm"
                              value={oneDayValue}
                              label="Select Date"
                              placeholder="Select Date"
                              onChange={handleDateChange}
                              disabled={dateRangeVal?.length}
                            />
                          </Box>
                        </>
                      )}
                    </Box>
                    <Box className={classes.btn_container}>
                      <Button
                        size="sm"
                        radius={"md"}
                        color="gray"
                        variant="outline"
                        onClick={() => {
                          if (selectedCategory === "facility")
                            setTempFacility(null);
                          if (selectedCategory === "client")
                            setTempClient(null);
                          if (selectedCategory === "staff")
                            setTempCreatedBy(null);
                          if (selectedCategory === "noteType")
                            setTempNoteType(null);
                          if (selectedCategory === "date") {
                            setDateRangeVal([]);
                            setOneDayValue(null);
                          }
                        }}
                      >
                        Reset
                      </Button>
                      <Button
                        radius={"md"}
                        size="sm"
                        disabled={loading}
                        onClick={handleApplyFilter}
                        className={classes.btnPrimary}
                      >
                        Apply
                      </Button>
                    </Box>
                  </>
                )}
              </Menu.Dropdown>
            </Menu>
          )}
        </Box>

        {statusTab !== "drafts" && hasActiveFilters && (
          <Box className={classes.activeFiltersBar}>
            {activeFilters.facility && (
              <Box className={classes.filterChip}>
                <Text size="xs">
                  Facility: {getFacilityName(activeFilters.facility)}
                </Text>
                <LuX size={12} onClick={() => handleRemoveFilter("facility")} />
              </Box>
            )}
            {activeFilters.client && (
              <Box className={classes.filterChip}>
                <Text size="xs">
                  Client: {getClientName(activeFilters.client)}
                </Text>
                <LuX size={12} onClick={() => handleRemoveFilter("client")} />
              </Box>
            )}
            {activeFilters.createdBy && (
              <Box className={classes.filterChip}>
                <Text size="xs">
                  Staff: {getStaffName(activeFilters.createdBy)}
                </Text>
                <LuX
                  size={12}
                  onClick={() => handleRemoveFilter("createdBy")}
                />
              </Box>
            )}
            {activeFilters.noteTypeFilter && (
              <Box className={classes.filterChip}>
                <Text size="xs">
                  Note Type: {getNoteTypeName(activeFilters.noteTypeFilter)}
                </Text>
                <LuX
                  size={12}
                  onClick={() => handleRemoveFilter("noteTypeFilter")}
                />
              </Box>
            )}
            {dateRange && (
              <Box className={classes.filterChip}>
                <Text size="xs">
                  Date: {moment(dateRange[0]).format("MM/DD/YY")} -{" "}
                  {moment(dateRange[1]).format("MM/DD/YY")}
                </Text>
                <LuX size={12} onClick={() => handleRemoveFilter("date")} />
              </Box>
            )}
            <Text
              className={classes.clearAllLink}
              onClick={handleResetAllFilters}
            >
              Clear all
            </Text>
          </Box>
        )}

        {statusTab === "drafts" ? (
          <Box className={classes.tableCard}>
            <DraftNotesTab onEditDraft={handleEditDraft} onViewDraft={openDraftView} />
          </Box>
        ) : (
          <Box className={classes.tableCard}>
            <NoteTable
              openModal={(data) => {
                setView(false);
                setData(data);
                setOpen(true);
              }}
              openViewModal={(data, opts) => {
                setData(data);
                setHideApproveReject(!opts?.showApprovalActions);
                setIsViewNoteOpen(true);
              }}
              setView={(data) => {
                setView(true);
              }}
              onDuplicate={handleDuplicateNote}
              onEditDraft={handleEditDraft}
              onViewDraft={openDraftView}
              onDraftDeleted={refetchNotes}
              sortField={sortField}
              sortOrder={sortOrder}
              currentPage={currentPage}
              dateRange={dateRange}
              activeFilters={activeFilters}
              setOpenModal={setOpenModal}
              setOpen={setOpen}
            />
            {notes?.notes?.length > 0 && (
              <CustomPagination
                itemsPerPage={ITEMS_PER_PAGE}
                data={notes?.count}
                currentPage={currentPage}
                handlePageChange={handlePageChange}
                showSummary
                className={classes.paginationFooter}
                paginationStyles={notePaginationStyles}
              />
            )}
          </Box>
        )}

        <NoteTypeSelectModal
          save={setOpen}
          opened={opened}
          title={"Add Note"}
          onclose={(nType) => {
            close();
            setNoteType(nType);
          }}
        />
        <NoteReportDrawer
          drawerOpen={noteReportDrawerOpened}
          drawerClose={noteReportDrawerClose}
        />
      </Box>
    </Box>
  );
};

export default Note;
